import { BrowserCacheLocation, Configuration } from "@azure/msal-browser";

import { env } from "configs";

// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
  MOBILE: "MOBILE",
};

// Auth
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const AUTH_SIGN_UP_REQUEST = "AUTH_SIGN_UP_REQUEST";
export const AUTH_SIGN_UP_SUCCESS = "AUTH_SIGN_UP_SUCCESS";
export const AUTH_SIGN_UP_FAILURE = "AUTH_SIGN_UP_FAILURE";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";
export const AUTH_SETUP_PASSWORD_REQUEST = "AUTH_SETUP_PASSWORD_REQUEST";
export const AUTH_SETUP_PASSWORD_SUCCESS = "AUTH_SETUP_PASSWORD_SUCCESS";
export const AUTH_SETUP_PASSWORD_FAILURE = "AUTH_SETUP_PASSWORD_FAILURE";

export const INITIAL_CONFIGS = `{"productTypes":[{"label":"กางเกง","grades":[{"label":"A","min_price":100,"max_price":150},{"label":"A-","min_price":80,"max_price":120},{"label":"B","min_price":60,"max_price":100}]},{"label":"เสื้อ","grades":[{"label":"A","min_price":100,"max_price":150},{"label":"A-","min_price":80,"max_price":120},{"label":"B","min_price":60,"max_price":100}]}],"productDetails":[{"label":"กระดุม","grades":[{"label":"A","min_price":50,"max_price":70},{"label":"A-","min_price":40,"max_price":60},{"label":"B","min_price":30,"max_price":50}]},{"label":"ซิบสีเงิน","grades":[{"label":"A","min_price":50,"max_price":70},{"label":"A-","min_price":40,"max_price":60},{"label":"B","min_price":30,"max_price":50}]}],"grades":[{"label":"A","description":"ผ้าเนื้อดีที่สุด"},{"label":"A-","description":"ผ้าเนื้อดี"},{"label":"B","description":"ผ้าเนื้อดีรองลงมา"},{"label":"B-","description":"ผ้าเนื้อดีรองลงมาอีก"},{"label":"C","description":"ผ้าเนื้อปานกลาง"},{"label":"C-","description":"ผ้าเนื้อปานกลางค่อนไปทางหยาบ"}],"productSizes":[{"label":"XL"},{"label":"L"},{"label":"M"},{"label":"S"},{"label":"SS"}],"productColors":[{"label":"ดำ"},{"label":"แดง"},{"label":"เขียว"},{"label":"เหลือง"}],"supplierTypes":[{"label":"ตัด"},{"label":"แก้"},{"label":"เย็บ"}],"materialTypes":[{"label":"ผ้า Textile"},{"label":"ผ้า Drytech"}],"materialUnits":[{"label":"นิ้ว"},{"label":"เมตร"},{"label":"วา"},{"label":"คืบ"}],"frontOfficeTermAndConditionUrl":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.","frontOfficeConsentUrl":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."}`;

export const BOOKING_STATUS_TEXT = {
  waiting: "รอยืนยัน",
  confirmed: "ยืนยันการจอง",
  paid: "ชำระเงินแล้ว",
  complete: "เสร็จสมบูรณ์",
  canceled: "ยกเลิก",
};

export const msalConfig: Configuration = {
  auth: {
    clientId: env.REACT_APP_MSAL_CLIENT_ID,
    authority: env.REACT_APP_MSAL_AUTHORITY,
    redirectUri: env.REACT_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: env.REACT_APP_MSAL_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
